export default {
  hover: 0,
  autoPlay: 1,
  click: 2
};



// WEBPACK FOOTER //
// ./components/item/videos/videoPlayModes.js